<style lang="scss" scoped>
.tooltip {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    font-size: 8px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-left: 4px;
    cursor: default;

    @apply bg-green;
}
</style>

<template>
    <div id="tooltip" class="inline-flex">
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <span class="tooltip">i</span>
        </template>
    </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling
import "tippy.js/themes/light.css";

export default {
    props: {
        text: {
            type: String,
            required: true
        }
    },

    mounted() {
        tippy("#tooltip", {
            theme: "light",
            content: this.text
        });
    }
};
</script>
